module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_short_front.3b9c8cf4.png";